import { jsx as _jsx } from "react/jsx-runtime";
import { NumberInput } from "react-admin";
import { useWatch } from "react-hook-form";
export var ManagedNumberInput = function (_a) {
    var source = _a.source, label = _a.label, defaultValue = _a.defaultValue, sourceToWatch = _a.sourceToWatch, isDisabled = _a.isDisabled, min = _a.min;
    var selectedPolicy = useWatch({ name: sourceToWatch });
    return (_jsx(NumberInput, { source: source, disabled: isDisabled(selectedPolicy), label: label, min: min, defaultValue: defaultValue, style: { flex: 1 } }));
};
